export { default } from './TrailLabel';
